<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "@/assets/style/index.scss";
</style>
<style>
@import "./static/font/font.css";
*{
  /*font-size: 0;*/
  padding: 0;
  margin: 0;
}
#app {
  /*font-family: PingFang SC;*/
  font-family: SourceHanSansCN;
  box-sizing: border-box;
}


@media screen and (max-width: 1400px) {
  #app{
    font-family: PingFang SC;
  }
}
</style>
